/**
 * The 27 EU member states, for the buy page's hint - D-16.
 *
 * **Restated from the server's list on purpose, and guarded.** The client
 * cannot import from the server workspace, and the alternative - asking the API
 * which countries are in the EU - would be a request on every page load to
 * answer a question that changes when a treaty does.
 *
 * `client/src/lib/buyGate.test.ts` reads `server/src/modules/tax/countries.ts`
 * off disk and fails if the two lists differ, on the `emDashes` and
 * `adminDisplay` precedent: a constant restated in two places with a comment
 * asking the next person to keep them in step is exactly the shape that goes
 * stale.
 */
export const EU_COUNTRIES: readonly string[] = [
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU',
  'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
];
